import { isFilled } from "@prismicio/client";
import { PrismicImage, PrismicLink, PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.ImgTxtSlice} ImgTxtSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ImgTxtSlice>} ImgTxtProps
 * @type {import("react").FC<ImgTxtProps>}
 */
const ImgTxt = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`framing padding-x padding-y flex flex-col gap-6 md:gap-10 xl:gap-20 ${slice.variation === "default" ? "lg:flex-row-reverse" : "lg:flex-row"} items-center text-black`}
    >
      <div className="lg:w-1/2 flex flex-col gap-8">
        {isFilled.richText(slice.primary.text) && (
          <div className="flex flex-col gap-4 underline-custom">
            <PrismicRichText
              field={slice.primary.text}
              components={{
                heading2: ({ children }) => <h2 className="h2">{children}</h2>,
                heading3: ({ children }) => <h3 className="h3">{children}</h3>,
                paragraph: ({ children }) => <p className="p-sm">{children}</p>,
                list: ({ children }) => <ul className="list-puce-ams">{children}</ul>,
                listItem: ({ children }) => <li className="mb-2 last:mb-0">{children}</li>,
                oList: ({ children }) => <ol className="list-decimal list-inside">{children}</ol>,
                oListItem: ({ children }) => <li className="mb-2 last:mb-0">{children}</li>,
              }}
            />
          </div>
        )}

        {isFilled.link(slice.primary.cta) && (
          <PrismicLink field={slice.primary.cta} className="cta cta-orange cta-text md:mx-auto lg:mx-0">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-5 md:w-5">
              <path d="M25 1L0.999998 10.9988L11.4514 14.5486L15.0012 25L25 1Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M10.8574 15.1425L2.37186 23.628" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            {slice.primary.cta.text}
          </PrismicLink>
        )}
      </div>
      {isFilled.image(slice.primary.img) && (
        <div className="lg:w-1/2 relative self-stretch overflow-hidden rounded-2xl">
          <PrismicImage className="lg:absolute lg:absolute-center w-full h-full max-h-110 lg:max-h-none object-cover"
            field={{
              ...slice.primary.img,
              alt: slice.primary.img.alt || "Image d'illustration",
            }}
          />
        </div>
      )}
    </section>
  );
};

export default ImgTxt;
